import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../../components/sidebar";
import Header from "../../components/header";
import "../../assets/CSS/dashboard.css";
import "../../assets/CSS/forms.css";
import API_BASE_URL from "../../config";
import "../../assets/CSS/loader.css";
import { authFetch } from "../../utility/AuthFetch";

function Mail_Excel() {
  const navigate = useNavigate();
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const validExtension = file.name.toLowerCase().endsWith(".xlsx");

    if (!validExtension) {
      alert("Please select an Excel (.xlsx) file.");
      e.target.value = ""; // Clear the selection
      return;
    }

    const fileName = file.name.toLowerCase();
    const validFileNames = [
      "demat.xlsx",
      "mutual_fund.xlsx",
      "referral.xlsx",
      "insurance.xlsx",
    ];
    if (!validFileNames.includes(fileName)) {
      alert(
        "Invalid file name. Please select a file named Demat.xlsx, Mutual_Fund.xlsx, Referral.xlsx, or Insurance.xlsx.",
      );
      e.target.value = "";
      return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

    setIsSubmitting(true);
    setLoader(true);

    const formData = new FormData(formRef.current);

    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/mail-master-excel`,
        {
          method: "POST",
          body: formData,
        },
      );

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Welcome Mail sent successfully");
        formRef.current.reset();
      } else {
        alert(result.error || "Error sending mail");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Server error. Please try again later.");
    } finally {
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />
        <div id="form-content">
          <div id="form-header">
            <p>Welcome Mail</p>
          </div>
          <hr />
          <form id="form" ref={formRef}>
            <div id="form-input">
              <label htmlFor="excel-file">
                Excel File{" "}
                <span className="required">
                  (File name should be Demat.xlsx / Mutual_Fund.xslx /
                  Referral.xslx / Insurance.xlsx) *
                </span>
              </label>
              <input
                type="file"
                name="excel-file"
                id="excel-file"
                placeholder="Select Excel File"
                required
                accept=".xlsx"
                onChange={handleFileChange}
              />
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              WELCOME MAIL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mail_Excel;
